import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockProcess } from '../mock';

const Process = () => {
  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our{' '}
            <span className="bg-gradient-to-r from-[#2CC84B] to-[#00BCD4] bg-clip-text text-transparent">
              Installation
            </span>{' '}
            Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Simple, transparent, and hassle-free solar installation in 5 easy steps
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Vertical Line */}
            <div className="hidden md:block absolute left-8 top-8 bottom-8 w-0.5 bg-gradient-to-b from-[#2CC84B] to-[#00BCD4]"></div>

            {/* Process Steps */}
            <div className="space-y-12">
              {mockProcess.map((step, index) => (
                <div key={step.step} className="relative flex items-start gap-6">
                  {/* Step Number Circle */}
                  <div className="flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10" style={{background: 'linear-gradient(135deg, #2CC84B, #00BCD4)'}}>
                    {step.step}
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-white rounded-xl p-6 shadow-md hover:scale-105 hover:shadow-[0_0_20px_rgba(0,188,212,0.2)] transition-all duration-300">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                          {step.title}
                        </h3>
                        <p className="text-gray-600">
                          {step.description}
                        </p>
                      </div>
                      <CheckCircle2 className="w-6 h-6 text-[#2CC84B] flex-shrink-0" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Timeline Summary */}
          <div className="mt-12 bg-gradient-to-r from-[#2CC84B]/5 to-[#00BCD4]/10 rounded-xl p-8 text-center border border-[#2CC84B]/20">
            <p className="text-lg text-gray-700">
              <span className="font-bold text-[#2CC84B]">Total Timeline:</span> Complete installation in just{' '}
              <span className="font-bold text-2xl text-[#00BCD4]">15-20 days</span> from site visit to commissioning
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
